import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {LoadingComponent} from 'recupero-comunes'
import { Card, Container } from 'react-bootstrap'
import { Auth } from 'recupero-comunes'
import { configuracionFormAction, obtenerCriteriosFechaAction, obtenerDeclaracionPolicialAction, obtenerEstadosCasoAction, obtenerRangoFechas, obtenerSituacionSiniestroAction, 
  obtenerTareasAction, obtenerTareasUsuarioAction, obtenerTipoGestionAction, obtenerInstanciaJudicial, obtenerIndLesionados, obtenerAsignaGestion } from '../../store/actions/encargado-cia-action'
import BuscarCasos from './buscar-casos'
import BandejaCasos from './bandeja-casos'

const AreaGestionCompania = () => {
    const [loading, setLoading]=useState(false)
    const { rutUsuario, rutOrganizacion, roles } = Auth.currentUser()
    const dispatch = useDispatch()
    const data_encargado = useSelector((state) => state.encargado_compania)
    const {cfg_form} = data_encargado
    const [tipoGestion, setTipoGestion]=useState(null)//Recupero entre cias

    useEffect(() => {
      //console.log("index.roles: ", roles);
      let tg = "235001";
      roles && roles.forEach(value => {
        if (value.rol === "70RESDECIAS") {
          tg = "235005";          
        }
     })
     setTipoGestion(tg);
    }, [])

    useEffect(() => {
      setLoading(true)
        let query = Buffer.from(
            JSON.stringify({ idform: 1, rutcia: rutOrganizacion })
        ).toString('base64')
        dispatch(configuracionFormAction(query))
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, parametro: 1 })
              ).toString('base64')
              dispatch(obtenerRangoFechas(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({
                  rutcia: rutOrganizacion,
                  rutusr: rutUsuario,
                  flujo: 1,
                  todos: document.getElementById('todos')
                    ? document.getElementById('todos').checked
                    : false
                })
              ).toString('base64')
              dispatch(obtenerTareasAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 200 })
              ).toString('base64')
              dispatch(obtenerEstadosCasoAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 207 })
              ).toString('base64')
              dispatch(obtenerTipoGestionAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 201 })
              ).toString('base64')
              dispatch(obtenerSituacionSiniestroAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 202 })
              ).toString('base64')
              dispatch(obtenerDeclaracionPolicialAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 29 })
              ).toString('base64')
              dispatch(obtenerCriteriosFechaAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 1 })
              ).toString('base64')
              dispatch(obtenerTareasUsuarioAction(query))
         })
         .then(()=>{
          let query = Buffer.from(
            JSON.stringify({ tipoGestion: null, ambitoGestion: null, idSituacion: null, idModoIngreso: 238006 })
          ).toString('base64')
          dispatch(obtenerInstanciaJudicial(query))
        })
        .then(()=>{
          let query = Buffer.from(
              JSON.stringify({ rutcia: rutOrganizacion, concepto: 203 })
            ).toString('base64')
            dispatch(obtenerIndLesionados(query))
        })
        .then(()=>{
          let query = Buffer.from(
              JSON.stringify({ rutcia: rutOrganizacion, concepto: 279})
            ).toString('base64')
            dispatch(obtenerAsignaGestion(query))
        })
        .then(()=>setLoading(false))
        
     }, [dispatch])
    
   
    
    
    return (
        <div> 
             <LoadingComponent show={loading}/>
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                  {cfg_form &&  `${cfg_form['bandejatareas-title']}`}</Card.Header>
                <Card.Body>
                        <BuscarCasos tipoGestion={tipoGestion}  />
                        <BandejaCasos  />
                  
             </Card.Body>
            </Card>
            </Container> 
        </div>
    )
}

export default AreaGestionCompania
